
import ChatForm from "@/components/application/interest/ChatForm"
import OabotCard from "@/components/onboarding/OabotCard"

import onboardingSteps from "@/components/onboarding/onboardingSteps"
import traineeNavigationMixin from "@/mixins/traineeNavigationMixin"

export default {
    name: "Onboarding",
    components: { ChatForm, OabotCard },
    mixins: [traineeNavigationMixin],
    data: () => ({
        onboardingSteps,
    }),
    methods: {
        async onFinish(formData) {
            this.$refs.onboardingForm.pushMessage({
                body: `Super! Danke ${this.$auth.user?.trainee.firstname}.\nViel Spaß auf Oabat!`,
                type: "regular",
            })
            const trainee = {
                class: String(formData["class"].data),
                school_base_id: formData["school"].data.id,
                primary_address: {
                    latitude: formData["region"].data.latitude,
                    longitude: formData["region"].data.longitude,
                    city: formData["region"].data.name,
                },
                highest_graduation: formData["graduation"].data,
            }

            this.$refs.onboardingForm.remove()
            await this.$store.dispatch("account/completeOnboarding", trainee)
            await this.$router.push(traineeNavigationMixin)
            this.$store.dispatch("account/setOnboarding", false)
            this.$emit("finish")
        },
    },
}
